export default "__VITE_ASSET__Bg_SXm0K__"